// src/contexts/LanguageContext.js
import React, { createContext, useState, useContext } from "react";
import i18n from "i18next";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("fr");

  const changeLanguage = (lng) => {
    setLanguage(lng);
    i18n.changeLanguage(lng); // Update i18n globally
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
